import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  COLUMN_SALES_GROUP_ID,
  COLUMN_ENTRY_USER_ID,
  COLUMN_DESK_ID,
} from "shared/cubiq-services/model/OrdersTableDefinitionFactory.constants";
export class ScratchPadOrder {
  orderId: string;
  orderRef: string;
  rootOrder: CubiqTS.OrderRequestDataImpl | CubiqTS.FixingOrderRequestData;
  key: string;
  base: string;
  nonBase: string;
  orderState: string;
  clientCode: string;
  accountCode: string;
  product: CubiqTS.Product;
  instrument: string;
  requestOrderType: CubiqTS.RequestOrderType;
  orderType: CubiqTS.OrderType;
  clientInt: CubiqTS.OrderIntent;
  fixedCcy: string;
  fixedAmount: string;
  requestRate?: string;
  deskId: string;
  salesGroupId: string;
  entryUserId: string;
  valueDate: CubiqTS.StandardDate;
  markup: string;
  markupType: CubiqTS.MarkUpType;
  forwardTrackingType?: CubiqTS.RequestTrackingType;
  fixingSourceCd: string;
  fixingDate: CubiqTS.StandardDate;
  activationDetails?: CubiqTS.ActivationDetailsImpl;
  expiryDetails?: CubiqTS.ExpiryDetailsImpl;
  traderGroup: string;
  comments1: string;
  comments2: string;
  stpHold: boolean;
  fillTypeRestriction?: CubiqTS.RequestorFillTypeRestriction;
  isPrivateOrder: boolean;
  siblingId?: string;
  siblingOrderId?: string;
  fillSupport?: CubiqTS.FillSupport;
  tenor: CubiqTS.Tenor;
  clTrader: string;
  externalClientReference: string;
  oldClOrdId: string;
  oldSiblingRefId: string;
  isProcessing: boolean;
  sibling?: CubiqTS.LinkedRelationshipImpl;
  childRelationships?: Array<CubiqTS.LinkedRelationshipImpl>;
  errors: string;
  fixingTime?: CubiqTS.StandardTime;

  activationTimeUnix?: number = 0;
  expiratonTimeUnix?: number = 0;

  oboClient?: string;
  oboAccount?: string;

  customValues: Array<CubiqTS.CustomValueImpl>;

  tslDistancePips: string;
  tslStartRate: string;

  multiAllocation: boolean;
  swapValueDate: string;
  /** Tooltip for multi-allocation BMs showing all allocations  */
  productTooltip: string;

  /** Display label for BM fixing - also used for bulking comparison */
  bmFixingDateLabel: string;
  /** Fixing date for BMs and limits used for sorting */
  fixingDateMoment: CubiqTS.Moment;
  /** Fixing time for BMs used for sorting */
  bmFixingTime: string;

  channelCd: string;

  fwdNettingId: string;

  constructor() {}
}
